import React from "react";

export default function Contact() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12 text-white md:mt-14">
      <h1 className="text-3xl font-bold mb-6 text-lime-400">📬 Contact Us</h1>

      <p className="mb-4">
        Have questions, feedback, or need support? We’re here to help. At{" "}
        <strong>iqcage.com</strong>, we believe in building trust and staying
        connected with our community.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">💬 General Inquiries</h2>
      <p className="mb-4">
        For any general questions or partnership opportunities, reach out to us
        via email:
      </p>
      <p className="mb-4">
        📧{" "}
        <a href="mailto:info@iqcage.com" className="text-lime-400 underline">
          info@iqcage.com
        </a>
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">🛠️ Technical Support</h2>
      <p className="mb-4">
        Facing a technical issue with your account or a game? Our support team
        is ready to assist you:
      </p>
      <p className="mb-4">
        📧{" "}
        <a href="mailto:support@iqcage.com" className="text-lime-400 underline">
          support@iqcage.com
        </a>
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">⏰ Support Hours</h2>
      <p className="mb-4">
        We aim to respond to all queries within 24 hours.
        <br />
        Support Hours:{" "}
        <strong>Monday – Sunday, 9 AM to 11 PM (GMT+5:30)</strong>
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">📍 Social Media</h2>
      <p className="mb-4">Follow us for updates, news, and giveaways:</p>
      <ul className="list-disc ml-6 space-y-2">
        <li>
          Telegram:{" "}
          <a
            href="https://t.me/iqcage"
            target="_blank"
            rel="noopener noreferrer"
            className="text-lime-400 underline"
          >
            @iqcage
          </a>
        </li>
        <li>
          Instagram:{" "}
          <a
            href="https://instagram.com/iqcage"
            target="_blank"
            rel="noopener noreferrer"
            className="text-lime-400 underline"
          >
            @iqcage
          </a>
        </li>
      </ul>

      <p className="mt-8 text-sm text-slate-400">
        Last updated: {new Date().toLocaleDateString()}
      </p>
    </div>
  );
}
